import React, { useContext, useEffect, useState } from 'react';
import { useParams } from 'react-router-dom';
import { Alert, Button, Checkbox, Select, Input, Field, Loader } from '@itds/elements/index.js';

import { AgencyContext } from '@brokerage/contexts/AgencyContext';

import { Api } from '@brokerage/utils/Api';

const General = () => {
  const params = useParams();

  const { agency, loadAgency, member_emails } = useContext(AgencyContext);
  const [data, setData] = useState({
    account_owner_id: agency.account_owner_id,
    agent_support_contact: agency.agent_support_contact,
    allow_new_member_marketing: agency.allow_new_member_marketing,
    billing_contact_id: agency.billing_contact_id,
    imo_group: agency.imo_group,
    name: agency.name,
    support_contact_id: agency.support_contact_id,
    use_mixpanel: agency.use_mixpanel,
    hexure_health_analyzer: agency.hexure_health_analyzer,
    is_health_analyzer_reasoning_enabled: agency.is_health_analyzer_reasoning_enabled
  });

  const [errors, setErrors] = useState([]);
  const [error_message, setErrorMessage] = useState();
  const [success_message, setSuccessMessage] = useState();

  useEffect(() => {
    return () => {
      setErrorMessage(null);
      setSuccessMessage(null);
    };
  }, []);

  const handleInputChange = (name, e) => {
    setData({ ...data, [name]: e.target.value });
  };

  const handleCheckboxChange = (name, e) => {
    setData({ ...data, [name]: e.target.checked });
  };

  const handleSave = () => {
    const errors = [];

    if (!data.name) {
      errors.push('name');
    }

    setErrors(errors);

    if (!errors.length) {
      window.scrollTo(0, 0);

      Api.updateAgency(params.agency_id, data)
        .then(response => {
          const { status } = response;

          if (status === 200) {
            loadAgency(params.agency_id);
            setSuccessMessage('Agency updated successfully');
          }
        })
        .catch(error => {
          if (error) {
            setErrorMessage('Unable to update Agency');
          }
        });
    }
  };

  return !agency ? (
    <Loader />
  ) : (
    <>
      {error_message ? <Alert type='error'>{error_message}</Alert> : null}
      {success_message ? <Alert type='success'>{success_message}</Alert> : null}

      <Field label='Name'>
        <Input
          invalid={errors.includes('name')}
          onChange={handleInputChange.bind(null, 'name')}
          required={true}
          style={{ width: '49%' }}
          value={data.name}
        />
      </Field>

      <div style={{ width: '32.3%' }}>
        <Field label='IMO Group'>
          <Select
            onChange={handleInputChange.bind(null, 'imo_group')}
            options={[
              { value: '', label: 'None' },
              { value: 'ain', label: 'AIN (Advantage Insurance Network)' },
              { value: 'nba', label: 'NBA (National Brokerage Agencies)' },
              { value: 'ida', label: 'IDA (Insurance Designers America)' },
              { value: 'tma', label: 'TMA (The Marketing Alliance)' },
              { value: 'cps', label: 'CPS' },
              { value: 'lifemark_partners', label: 'Lifemark Partners' },
              { value: 'aimcor', label: 'AimcoR' },
              { value: 'nfp', label: 'NFP' },
              { value: 'bramco', label: 'Bramco' },
              { value: 'tellus', label: 'Tellus' },
              { value: 'capitas', label: 'Capitas' }
            ]}
            value={data.imo_group}
          />
        </Field>
      </div>

      <div style={{ width: '32.3%' }}>
        <Field label='Account Owner'>
          <Select
            onChange={handleInputChange.bind(null, 'account_owner_id')}
            options={member_emails}
            placeholder='-- Select Member --'
            value={data.account_owner_id}
          />
        </Field>
      </div>

      <div style={{ width: '32.3%' }}>
        <Field label='Billing Contact'>
          <Select
            onChange={handleInputChange.bind(null, 'billing_contact_id')}
            options={member_emails}
            placeholder='-- Select Member --'
            value={data.billing_contact_id}
          />
        </Field>
      </div>

      <div style={{ width: '32.3%' }}>
        <Field label='Support Contact'>
          <Select
            onChange={handleInputChange.bind(null, 'support_contact_id')}
            options={member_emails}
            placeholder='-- Select Member --'
            value={data.support_contact_id}
          />
        </Field>
      </div>

      <Field label='Agent Support Contact'>
        <Input
          onChange={handleInputChange.bind(null, 'agent_support_contact')}
          style={{ width: '32.3%' }}
          value={data.agent_support_contact}
        />
      </Field>

      <Checkbox
        checked={data.use_mixpanel}
        label='Use MixPanel'
        onChange={handleCheckboxChange.bind(null, 'use_mixpanel')}
      />

      <Checkbox
        checked={data.hexure_health_analyzer}
        label='Hexure Health Analyzer'
        onChange={handleCheckboxChange.bind(null, 'hexure_health_analyzer')}
      />

      <Checkbox
        checked={data.is_health_analyzer_reasoning_enabled}
        label='Health Analyzer Reasoning'
        onChange={handleCheckboxChange.bind(null, 'is_health_analyzer_reasoning_enabled')}
      />

      <div style={{ marginTop: 40 }}>
        <Button inline={true} onClick={handleSave}>
          Save Changes
        </Button>
      </div>
    </>
  );
};

export default General;
